import { createRoot } from "@wordpress/element";
import App from "./components/App";

document
	.querySelectorAll(".wp-block-weather-weather-forecast-ten-days-card")
	.forEach((el) => {
		const root = el.querySelector(".weather-forecast-ten-days__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
